import React, { PureComponent, Children } from 'react'
import { string, node, func } from 'prop-types'
import classNames from 'classnames'
import { withI18n } from '@active/react-utils/i18n'

import LayoutContent from './LayoutContent'
import ErrorContent from './ErrorContent'
import defaultConfig from './defaultLayoutConfig.json'

const {
  applicationNamespace: appNS,
  connector: { level: levelConnector },
} = defaultConfig

const ERROR_MSG_CONTAINER_ID = 'passportAppGloalErrorMsg'
const LAYOUT_ORDER = [
  'header',
  key => <div key={key} id={ERROR_MSG_CONTAINER_ID} />,
  'title',
  'subTitle',
  'main',
  'footer',
]

const subNodeBuilder = nameSpace => function subNode(subClassName, child, idx) {
  if (child) {
    return (
      <div
        key={idx}
        className={classNames(
          {
            [`${appNS}${levelConnector}${subClassName}`]: true,
            [`${levelConnector}${subClassName}`]: false,
          },
          `${nameSpace}${levelConnector}${subClassName}`,
        )}
      >
        {subClassName === 'title' ? <h1 className="h-style-clean">{child}</h1> : child}
      </div>
    )
  }
  return null
}

class DefaultComponentLayout extends PureComponent {
  static propTypes = {
    nameSpace: string,
    errMsg: string,
    messageType: string,
    children: node,
    Header: func,
  }

  static defaultProps = {
    nameSpace: null,
    errMsg: null,
    messageType: null,
    children: null,
    Header: null,
  }

  constructor(props) {
    super(props)
    const { nameSpace } = props
    this.subNode = subNodeBuilder(nameSpace)
  }

  getLayoutChildren = () => {
    const { children, Header } = this.props
    const layoutChildren = Children.toArray(children)
    if (Header) {
      layoutChildren.push(<LayoutContent header><Header /></LayoutContent>)
    }
    return layoutChildren
  }

  render() {
    const { nameSpace, errMsg, messageType } = this.props
    const children = this.getLayoutChildren()
    return (
      <div className={classNames(nameSpace)}>
        {LAYOUT_ORDER.map((comp, idx) => {
          if (typeof comp === 'string') {
            const child = children.filter(c => c && c.props[comp])[0]
            return this.subNode(comp, child, idx)
          }
          if (typeof comp === 'function') {
            return comp(idx)
          }
          return null
        })}
        <ErrorContent messageType={messageType} errorMsg={errMsg} />
      </div>
    )
  }
}

export default withI18n(DefaultComponentLayout)
